import { fetchPilot } from "../services/pilotsService";
import { usePublicData } from "./usePublicData";

export default function usePilotName(uid: string | null): string {
  const identity = usePublicData(`pilot:${uid ?? ""}`, () => (uid ? fetchPilot(uid) : Promise.resolve(null)));
  if (!uid) return "";
  if (identity.data) return identity.data.name || "Unnamed pilot";
  return identity.loading ? "Loading…" : "Pilot";
}
